import React, { createContext, useState, useMemo } from 'react';
import en from './i18n/en.json';
import de from './i18n/de.json';

export const LanguageContext = createContext(null);

const bundles = { en, de };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  const value = useMemo(
    () => ({
      language,
      switchLanguage: setLanguage,
      t: bundles[language],
    }),
    [language],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
